import { createDynamicMiddlewares } from 'redux-dynamic-middlewares'
import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'

import rootReducer from '~/reducers'

import analyticsMiddleware from '~/middleware/analytics'
import salesforceMiddleware from '~/middleware/salesforce'
import settingsMiddleware from '~/middleware/settings'

const dynamicMiddlewaresInstance = createDynamicMiddlewares()

const middlewares = [thunkMiddleware, dynamicMiddlewaresInstance.enhancer, salesforceMiddleware, analyticsMiddleware, settingsMiddleware]

const store = createStore(rootReducer, applyMiddleware(...middlewares))

export const addLoggerMiddleware = middleware => {
  dynamicMiddlewaresInstance.addMiddleware(middleware)
}

export default store
